import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateGroup = async ({ orgId, groupId, data }) => {
  const url = `v1/orgs/${orgId}/groups/${groupId}`
  const response = await axiosInstance.patch(url, JSON.stringify(data))
  return response?.data
}

export default updateGroup
